export default "__VITE_ASSET__DtyjtGm8__"